import api from '../../api/api'

// initial state
const state = {
  user: null,
  errors: {},
  //isLoaded: false
  status: {
    login: null,
    logout: null,
    getSession: null
  }
}

// getters
const getters = {}

// actions
const actions = {
  login ({ commit, state }, params) {
    commit('setErrors', {})
    commit('setStatus', { login: api.status.PENDING })
    return api.login(params).then((response) => {
      commit('setUser', response.data)
      commit('setStatus', { login: api.status.SUCCESS })
    }).catch((error) => {
      commit('setErrors', error.response.data.errors)
      commit('setStatus', { login: api.status.FAILURE })
    })
  },
  logout ({ commit, state }) {
    commit('setStatus', { logout: api.status.PENDING })
    return api.logout().then(response => {
      commit('setUser', null)
      commit('setStatus', { logout: api.status.SUCCESS })
    }).catch((error) => {
      commit('setStatus', { logout: api.status.FAILURE })
    })
  },
  getSession ({ commit, state }) {
    commit('setStatus', { getSession: api.status.PENDING })
    return api.getSession().then((response) => {
      commit('setUser', response.data.user)
      commit('booking/setBooking', response.data.booking, {root: true})
      commit('order/setOrder', response.data.order, {root: true})
      commit('setStatus', { getSession: api.status.SUCCESS })
    }).catch((error) => {
      commit('setStatus', { getSession: api.status.FAILURE })
    })
  },
  ensureSession ({ commit, state, dispatch }) {
    if (state.status.getSession != api.status.SUCCESS) {
      return dispatch('getSession')
    }
    return new Promise((resolve, reject) => {
      resolve()
    })
  }
}

// mutations
const mutations = {
  setUser (state, user) {
    state.user = user
    state.isLoaded = true
  },
  setErrors (state, errors) {
    state.errors = errors
  },
  setStatus (state, status) {
    Object.assign(state.status, status)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
